import { render } from "./list-class.vue?vue&type=template&id=8e89659e&lang=html"
import script from "./list-class.vue?vue&type=script&lang=js"
export * from "./list-class.vue?vue&type=script&lang=js"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__